import { compact } from 'lodash';
import {
  combineReducers,
  applyMiddleware,
  createStore,
  type Store,
} from 'redux';
import thunk from 'redux-thunk';
import { appUouBiMiddleware } from '../../common/bi-events/init-middleware';
import type { PlatformApi } from '../../common/controller/platform-api';
import commonReducers from '../../common/reducers';
import createRequests from '../../common/services/create-requests';
import type {
  AppParams,
  FedopsLogger,
  FlowAPI,
  PlatformAPIs,
} from '../../common/types';
import { eventMap } from '../bi-events/uou-events';
import tagCloudWidgetReducer from '../store/tag-cloud.reducer';
import { type TagCloudThunkExtraArgs } from '../types';

type CreateReduxStoreParams = {
  appParams: AppParams;
  platformApi: PlatformApi;
  compId: string;
  fedopsLogger: FedopsLogger;
  isEditor: boolean;
  platformAPIs: PlatformAPIs;
  bundleName: string;
  flowAPI: FlowAPI;
};

/** @deprecated Remove when merging {@link OOI_EXPERIMENTS.USE_NEW_TAG_CLOUD_SETTINGS_URL} */
export function createReduxStore({
  appParams,
  platformApi,
  compId,
  fedopsLogger,
  isEditor,
  platformAPIs,
  bundleName,
  flowAPI,
}: CreateReduxStoreParams) {
  // eslint-disable-next-line prefer-const
  let store: Store;

  const { request, platformizedRequest, aggregatorRequest } = createRequests({
    platformApi,
    bundleName,
    getStore: () => store,
    flowAPI,
  });

  const biMiddleware =
    !isEditor &&
    appUouBiMiddleware({
      platformAPIs,
      instanceId: appParams.instanceId,
      eventMap,
    });

  const middleware = compact([
    thunk.withExtraArgument({
      request,
      platformizedRequest,
      aggregatorRequest,
      platformApi,
      compId,
      appParams,
      fedopsLogger,
      httpClient: flowAPI.httpClient,
    } satisfies TagCloudThunkExtraArgs),
    biMiddleware,
  ]);

  const reducers = combineReducers({
    ...commonReducers,
    tagCloudWidget: tagCloudWidgetReducer,
  });

  const initialState = { experiments: flowAPI.essentials.experiments.all() };

  store = createStore(reducers, initialState, applyMiddleware(...middleware));

  return store;
}
